import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import WorkLog from "@/pages/WorkLog";
import Projects from "@/pages/Projects";
import Team from "@/pages/Team";
import Resources from "@/pages/Resources";
import Prices from "@/pages/Prices";
import ProjectOverview from "@/pages/ProjectOverview";
import Signoffs from "@/pages/Signoffs";
import SignoffDetail from "@/pages/SignoffDetail";
import Settings from "@/pages/Settings";
import PublicSignoff from "@/pages/PublicSignoff";
import ForcePasswordChange from "@/pages/ForcePasswordChange";
import ResetPassword from "@/pages/ResetPassword";

function Protected({ children, manager }) {
  const { user, loading } = useAuth();
  if (loading)
    return <div className="flex min-h-screen items-center justify-center bg-slate-950 text-slate-400">Laddar…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <ForcePasswordChange />;
  if (manager && !["owner", "partner"].includes(user.role)) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" theme="dark" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/reset/:token" element={<ResetPassword />} />
          <Route path="/sign/:token" element={<PublicSignoff />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/worklog" element={<Protected><WorkLog /></Protected>} />
          <Route path="/projects" element={<Protected manager><Projects /></Protected>} />
          <Route path="/team" element={<Protected manager><Team /></Protected>} />
          <Route path="/resources" element={<Protected manager><Resources /></Protected>} />
          <Route path="/prices" element={<Protected manager><Prices /></Protected>} />
          <Route path="/overview" element={<Protected manager><ProjectOverview /></Protected>} />
          <Route path="/signoffs" element={<Protected manager><Signoffs /></Protected>} />
          <Route path="/signoffs/:id" element={<Protected manager><SignoffDetail /></Protected>} />
          <Route path="/settings" element={<Protected manager><Settings /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
